type IconProps = React.HTMLAttributes<SVGElement>;

export const IllustrationCloseSpace = (props: IconProps) => {
	return (
		<svg viewBox="0 0 342 263" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M45.7891 230.5V110.858L291.006 14.8322V134.096L45.7891 230.5Z" fill="#F6F7F8" />
			<path d="M291.005 136.948V15.2108L136.98 76.0774L291.005 136.948Z" fill="black" stroke="black" />
			<path
				d="M59.0232 112.822C60.6658 112.177 62.1886 112.079 63.4503 112.437L63.6993 112.515L70.7516 115.319L58.7869 157.93L52.3446 154.515C51.6245 153.668 51.1846 152.518 51.1201 151.125L51.121 123.425C51.3286 119.195 54.7607 114.495 59.0232 112.822Z"
				fill="black"
				stroke="black"
			/>
			<rect
				x="0.469948"
				y="0.329269"
				width="17.1964"
				height="43.9692"
				rx="8.59821"
				transform="matrix(0.939896 -0.341462 3.50108e-08 1 56.5771 117.484)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path
				d="M59.0232 164.976C60.6658 164.332 62.1886 164.234 63.4503 164.591L63.6993 164.669L70.7516 167.473L58.7869 210.084L52.3446 206.669C51.6245 205.822 51.1846 204.673 51.1201 203.279L51.121 175.579C51.3286 171.35 54.7607 166.65 59.0232 164.976Z"
				fill="black"
				stroke="black"
			/>
			<rect
				x="0.469948"
				y="0.329269"
				width="17.1964"
				height="43.9692"
				rx="8.59821"
				transform="matrix(0.939896 -0.341462 3.50108e-08 1 56.5771 169.638)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path
				d="M148.191 173.703L82.9518 147.593L82.9518 97.309L87.2133 95.7035L148.191 119.231L148.191 173.703Z"
				fill="#BDFF9C"
				stroke="black"
			/>
			<rect
				x="-2.98023e-08"
				y="0.365395"
				width="65.812"
				height="94.0338"
				transform="matrix(0.930853 0.365395 -0.930853 0.365395 175.088 60.9163)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<rect
				x="-2.98023e-08"
				y="0.365395"
				width="66.1567"
				height="19.3686"
				transform="matrix(0.930853 0.365395 -0.930853 0.365395 143.602 73.444)"
				fill="#BDFF9C"
				stroke="black"
			/>
			<rect
				x="0.465426"
				y="0.317303"
				width="94.4433"
				height="53.8119"
				transform="matrix(0.930853 -0.365395 3.24028e-08 1 147.702 119.602)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<rect
				x="0.465426"
				y="0.317303"
				width="18.2953"
				height="15.7247"
				transform="matrix(0.930853 -0.365395 3.24028e-08 1 186.415 104.645)"
				fill="#BDFF9C"
				stroke="black"
			/>
			<path d="M33 116.372L309 8.03131" stroke="black" />
			<path d="M33 235.836L309 127.496" stroke="black" />
			<path d="M45.9122 99.206L45.9121 247.202" stroke="black" />
			<path d="M296.088 1.00232L296.088 146.012" stroke="black" />
			<path d="M78.1862 98.766V210.109M78.1862 210.109L88.0224 213.917M78.1862 210.109L46.2188 222.485" stroke="black" />
			<path
				d="M216.495 129L206.287 126.501C206.15 126.467 206.09 126.305 206.172 126.19L283.776 17.8566L296 13.0873L216.495 129Z"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path d="M33 116.369L309 8.02899" stroke="black" />
			<path d="M33 235.834L309 127.493" stroke="black" />
			<path d="M46 111.462L45.9121 247.199" stroke="black" />
			<path d="M296.088 1L296.088 146.009" stroke="black" />
			<path
				d="M296.566 131.647L216.305 249.441C216.194 249.604 215.939 249.525 215.939 249.328V129L296 13.5863L296.566 131.647Z"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path d="M206 126.931L205.375 246.55L215.384 249.226V129.035L206 126.931Z" fill="black" stroke="black" />
			<path
				d="M216.814 249.578L216.5 249.431L296.565 132.025C299.762 134.937 300.351 139.749 297.95 143.346L229.387 246.08C226.639 250.197 221.293 251.684 216.814 249.578Z"
				fill="#BDFF9C"
				stroke="black"
			/>
			<path
				d="M162.144 137C168.206 126.5 183.219 126.336 189.561 136.508L189.857 137L224.497 197C230.656 207.667 222.958 221 210.641 221H141.359C129.235 221 121.586 208.08 127.224 197.502L127.502 197L162.144 137Z"
				fill="#FFCBE2"
				stroke="black"
				strokeWidth="4"
			/>
			<path
				d="M173.948 184.453L172.584 162.409H179.272L177.908 184.453H173.948ZM172.76 194.001V187.621H179.14V194.001H172.76Z"
				fill="black"
			/>
			<path
				d="M190.939 238.462C193.315 238.672 194.457 240.115 193.657 241.835L193.573 242.003L189.915 248.86C188.792 250.966 185.3 252.537 182.491 252.245L182.222 252.21L173.465 250.897C170.988 250.525 170.139 248.754 171.5 246.911L171.64 246.732L176.687 240.539C178.079 238.831 180.922 237.669 183.34 237.796L183.572 237.812L190.939 238.462Z"
				fill="#FFCBE2"
				stroke="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.6522 197.269L10.0911 208.355C9.58515 209.929 11.2893 211.47 12.8851 210.881L18.7777 208.705C19.0889 208.59 19.4339 208.643 19.7269 208.799C19.8176 208.847 19.913 208.894 20.0129 208.939C24.9799 211.189 30.0448 213.35 35.1975 215.42C76.9902 232.211 113.297 243.569 160.57 248.223C162.285 248.391 164.006 247.948 164.728 247.16L171.823 239.42C173.184 237.936 171.369 236.214 168.149 235.872C126.388 231.428 85.0728 221.002 48.5189 206.316C45.6187 205.15 42.7483 203.953 39.9101 202.724C39.0858 202.366 39.1215 201.19 39.9642 200.879L41.0725 200.47C43.1123 199.716 42.3894 196.737 40.152 196.675L15.5256 196.001C14.656 195.977 13.9036 196.486 13.6522 197.269Z"
				fill="#F6F7F8"
			/>
			<path
				d="M10.0911 208.355L10.5671 208.507L10.0911 208.355ZM13.6522 197.269L13.1762 197.116L13.6522 197.269ZM12.8851 210.881L13.0583 211.35L12.8851 210.881ZM20.0129 208.939L19.8066 209.394L20.0129 208.939ZM35.1975 215.42L35.0111 215.884L35.1975 215.42ZM160.57 248.223L160.619 247.725L160.57 248.223ZM164.728 247.16L165.097 247.498V247.498L164.728 247.16ZM171.823 239.42L171.455 239.082L171.823 239.42ZM168.149 235.872L168.096 236.369L168.149 235.872ZM48.5189 206.316L48.7053 205.852L48.5189 206.316ZM41.0725 200.47L40.8993 200.001L41.0725 200.47ZM40.152 196.675L40.1383 197.175L40.152 196.675ZM15.5256 196.001L15.5393 195.501L15.5256 196.001ZM39.9101 202.724L40.1089 202.265L39.9101 202.724ZM39.9642 200.879L40.1375 201.348L39.9642 200.879ZM18.7777 208.705L18.9509 209.174L18.7777 208.705ZM10.5671 208.507L14.1283 197.422L13.1762 197.116L9.61501 208.202L10.5671 208.507ZM12.7118 210.412C12.113 210.633 11.48 210.461 11.0353 210.059C10.5909 209.657 10.3849 209.074 10.5671 208.507L9.61501 208.202C9.29125 209.209 9.68447 210.185 10.3646 210.8C11.0444 211.415 12.0613 211.718 13.0583 211.35L12.7118 210.412ZM18.6044 208.236L12.7118 210.412L13.0583 211.35L18.9509 209.174L18.6044 208.236ZM20.2193 208.484C20.1284 208.442 20.0426 208.4 19.9616 208.357L19.4922 209.24C19.5927 209.294 19.6975 209.345 19.8066 209.394L20.2193 208.484ZM35.3839 214.956C30.2376 212.889 25.1794 210.731 20.2193 208.484L19.8066 209.394C24.7803 211.648 29.8519 213.811 35.0111 215.884L35.3839 214.956ZM160.619 247.725C113.409 243.078 77.1508 231.737 35.3839 214.956L35.0111 215.884C76.8297 232.685 113.185 244.061 160.521 248.72L160.619 247.725ZM164.36 246.822C164.091 247.115 163.585 247.389 162.897 247.566C162.221 247.739 161.421 247.804 160.619 247.725L160.521 248.72C161.434 248.81 162.352 248.738 163.146 248.534C163.928 248.334 164.644 247.992 165.097 247.498L164.36 246.822ZM171.455 239.082L164.36 246.822L165.097 247.498L172.192 239.757L171.455 239.082ZM168.096 236.369C169.647 236.534 170.782 237.026 171.358 237.578C171.641 237.85 171.76 238.108 171.777 238.326C171.794 238.535 171.722 238.79 171.455 239.082L172.192 239.757C172.605 239.307 172.817 238.79 172.774 238.249C172.733 237.716 172.453 237.244 172.05 236.857C171.254 236.092 169.871 235.552 168.202 235.375L168.096 236.369ZM48.3325 206.78C84.9294 221.483 126.289 231.921 168.096 236.369L168.202 235.375C126.486 230.936 85.2161 220.52 48.7053 205.852L48.3325 206.78ZM39.7114 203.182C42.5537 204.414 45.4282 205.613 48.3325 206.78L48.7053 205.852C45.8091 204.688 42.9429 203.492 40.1089 202.265L39.7114 203.182ZM40.8993 200.001L39.791 200.41L40.1375 201.348L41.2458 200.939L40.8993 200.001ZM40.1383 197.175C41.0089 197.199 41.5726 197.781 41.7303 198.431C41.8855 199.071 41.6447 199.725 40.8993 200.001L41.2458 200.939C42.5402 200.461 42.9577 199.249 42.7021 198.195C42.449 197.152 41.5324 196.213 40.1657 196.176L40.1383 197.175ZM15.5119 196.501L40.1383 197.175L40.1657 196.176L15.5393 195.501L15.5119 196.501ZM14.1283 197.422C14.3063 196.867 14.8464 196.482 15.5119 196.501L15.5393 195.501C14.4655 195.472 13.5009 196.105 13.1762 197.116L14.1283 197.422ZM40.1089 202.265C39.702 202.089 39.714 201.505 40.1375 201.348L39.791 200.41C38.529 200.876 38.4695 202.644 39.7114 203.182L40.1089 202.265ZM18.9509 209.174C19.0986 209.119 19.2939 209.135 19.4922 209.24L19.9616 208.357C19.5739 208.151 19.0793 208.06 18.6044 208.236L18.9509 209.174Z"
				fill="black"
			/>
		</svg>
	);
};
